// Check if window is defined (so if in the browser or in node.js).
const isBrowser = typeof window !== "undefined"

export default isBrowser